import classNames from 'classnames';
import { FlexContainer, LoadingPlaceholder } from 'components';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserLocation } from 'state';
import { useSearchMainState } from './state';
import { SearchFilterForm, SearchResults, SearchToolbar } from './bricks';
import styles from './SearchMainScreen.module.scss';

/**
 * SearchMainScreen
 *
 * @return {JSX.Element}
 */
const SearchMainScreen = ({ className }) => {
  const state = useSearchMainState();
  const userLocationState = useUserLocation();
  const location = useLocation();

  useEffect(() => {
    if (!state.isInitialized) {
      state.init({ userLocationState });
      // return () => state.destroy();
    }
  }, [state, userLocationState]);

  useEffect(() => {
    if (state.isInitialized) {
      state.searchBrowserFilterState.update(location.search);
    }
  }, [state.isInitialized, state.searchBrowserFilterState, location.search]);

  useEffect(() => {
    return () => state.setFilterIsOpen(false);
  }, [state]);

  return state.isInitialized ? (
    <FlexContainer
      className={classNames(
        styles.SearchMainScreen,
        className,
        `${SearchMainScreen.displayName}`
      )}
      column
      gap
      flex
    >
      <SearchToolbar />
      {state.isFilterOpen ? <SearchFilterForm /> : <SearchResults />}
    </FlexContainer>
  ) : (
    <LoadingPlaceholder spinner padding />
  );
};

SearchMainScreen.displayName = 'SearchMainScreen';

export default observer(SearchMainScreen);
